import React, { useState } from "react";
import { connect } from "react-redux";
import ProfileFeedbackForm from "./_ProfileFeedbackForm";
import ProfileFeedbackDone from "./_ProfileFeedbackDone";
import { contactUs } from "../../services/Management/UserProfileService";

const ProfileFeedback = ({
  handleProfileFeedback,
  _,
  SidebarHiding,
  User,
  applicationType,
}) => {
  const [FeedbackDone, setFeedbackDone] = useState(false);

  const readFile = (file) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = function() {
        let bytes = Array.from(new Uint8Array(this.result));
        let base64StringFile = btoa(
          bytes.map((item) => String.fromCharCode(item)).join("")
        );
        resolve({
          content: base64StringFile,
          fileName: file.name,
          fileType: file.type,
        });
      };
      reader.readAsArrayBuffer(file);
    });
  };

  const sendEmail = (subject, message, senderEmail, category, files) => {
    let body = {
      subject: subject,
      message: message,
      senderEmail: senderEmail,
      category: category,
      applicationType,
    };
    let formData = { ...body };
    Promise.all(files.map(readFile))
      .then((attachments) => (formData.attachments = attachments))
      .then(() => contactUs(formData))
      .then((response) => console.log(response));
  };

  return (
    <div
      className={
        "notifications profile-sidebar contact-us" +
        (SidebarHiding ? " hiding" : "")
      }
      onClick={handleProfileFeedback}
    >
      <div
        className={
          "notifications-wrapper change-password" +
          (SidebarHiding ? " hiding" : "")
        }
        onClick={(e) => e.stopPropagation()}
      >
        <button className="btn btn-close" onClick={handleProfileFeedback}>
          <i className="icon-omni-close-circle" />
        </button>
        <h3>
          <i
            className="icon-omni-profile-arrow-left"
            onClick={handleProfileFeedback}
          />
          {_.ContactUs}
        </h3>
        {FeedbackDone ? (
          <ProfileFeedbackDone setFeedbackDone={setFeedbackDone} _={_} />
        ) : (
          <ProfileFeedbackForm
            setFeedbackDone={setFeedbackDone}
            SendFeedBack={sendEmail}
            _={_}
            User={User}
          />
        )}
      </div>
    </div>
  );
};
export const mapStateToProps = (state) => {
  const { _ } = state;
  return { _ };
};
export default connect(mapStateToProps)(ProfileFeedback);
